import { enumChartTypes, kAspectRatioLookup } from "../constants";
import { Optimizer } from "../CoreApp/Optimizer";
import { Globals } from "../CoreApp/Globals";

export function DoOptimizePage(
  rootNode,
  pageLayoutMgr,
  aspectRatio,
  allowSort,
  treeSingles,
  branchPrefs,
  param,
  selectedNode,
  docRef
) {
  var chartType = pageLayoutMgr.GetChartType();

  if (chartType === enumChartTypes.level || chartType === enumChartTypes.card || rootNode == null)
    return;

  // clamp: aspectRatio is an index into kAspectRatioLookup
  var lookupIdx = Math.max(0, aspectRatio - 1);
  aspectRatio = kAspectRatioLookup[lookupIdx];
  var optimizer = new Optimizer();

  // use this for info on index Globals._preflightInfo.fPageIndex
  if (Globals._preflightInfo) {
    var curT = Date.now();
  }

  optimizer.InitOptimizer(
    rootNode,
    pageLayoutMgr,
    aspectRatio,
    allowSort,
    treeSingles,
    branchPrefs
  );

  if (optimizer.HasBranchStyles(docRef)) {
    return;
  }

  optimizer.PerformOperations(param, selectedNode);

  optimizer.updateNodeStyle();
  if (Globals._preflightInfo) {
    //        console.log("Page " + Globals._preflightInfo.fPageIndex + " " + curT + " " + (Date.now() - curT));
  }
}
